import React from 'react';
import { Container } from '@mui/material';
import CompanyStepper from '../../components/company/CompanyStepper';

const CompanyPage = () => {
  return (
    <Container maxWidth="lg" sx={{ pt: 8, pb: 8 }}>
      <CompanyStepper />
    </Container>
  );
};

export default CompanyPage;
